import { memo } from "react";

interface TagProps {
   text: string;
   onPress: () => void;
   isSelected: boolean;
   index: number
}

const Tag = memo(({ text, onPress, isSelected, index }: TagProps) => {
   const selected = isSelected === false ? "check_link w-inline-block" : 'check_link check w-inline-block';
   return (<>

      <a href="#" onClick={onPress} className={selected}>
         <div>{text}</div>
      </a>
   </>)
})

export default Tag;